import React from "react";
import ReactECharts from "echarts-for-react";

const RevenueBreakdownPieChart: React.FC = () => {
  const options = {
    tooltip: {
      trigger: "item",
      backgroundColor: "#181B25",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
      formatter: "{a} <br/>{b} : {c} kWh ({d}%)",
    },
    grid: {
      left: "1%",
      right: "1%",
      top: "10%",
      bottom: "10%",
    },
    legend: {
      orient: "vertical",
      left: "right",
      top: "middle",
      data: ["Residential", "Commercial", "Industrial"],
      textStyle: {
        fontSize: 10,
        color: "#5F6368",
      },
    },
    series: [
      {
        name: "Revenue",
        type: "pie",
        radius: "88%",
        data: [
          { value: 335, name: "Residential" },
          { value: 310, name: "Commercial" },
          { value: 234, name: "Industrial" },
        ],
        itemStyle: {
          normal: {
            color: function (params: any) {
              const colorList = ["#9CE976", "#1976d2", "#db50f2"];
              return colorList[params.dataIndex];
            },
          },
        },
      },
    ],
  };

  return <ReactECharts option={options} />;
};

export default RevenueBreakdownPieChart;
